import React from 'react'

export const Deadlines = () => {
  return (
    <div className="container relative z-20 text-left">
      <div className="bg-white shadow-md">
        <div className="mx-auto p-8 sm:p-12 md:p-16">
          <h2 className="font-sans uppercase tracking-wider font-bold text-brand-red text-4xl sm:text-5xl leading-tight">
            Upcoming Elections and Deadlines
          </h2>
          <article className="mt-8 2xl:mt-12">
            <h3 className="font-sans uppercase font-medium tracking-wide text-2xl sm:text-3xl md:text-4xl leading-tight text-gray-500">
              primary registration deadline
            </h3>
            <p className="capitalize text-xl sm:text-2xl md:text-4xl leading-tight text-brand-red md:tracking-tight">
              Primary Registration is Closed
            </p>
          </article>

          <article className="mt-12 xl:mt-16 2xl:mt-20">
            <h3 className="font-sans uppercase font-medium tracking-wide text-2xl sm:text-3xl md:text-4xl leading-tight text-gray-500">
              Indiana State Primary Election
            </h3>
            <p className="capitalize text-xl sm:text-2xl md:text-4xl leading-tight text-brand-red md:tracking-tight">
              June 2, 2020
            </p>
            <h4 className="mt-3 font-bold capitalize md:text-xl leading-tight">
              Early Voting:
            </h4>
            <p className=" md:text-xl">Not available</p>
            <h4 className="mt-3 font-bold capitalize md:text-xl leading-tight">
              In-Person Absentee Voting:
            </h4>
            <p className=" md:text-xl">May 5, 2020 - June 1, 2020</p>
          </article>

          <article className="mt-12 xl:mt-16 2xl:mt-20">
            <h3 className="font-sans uppercase font-medium tracking-wide text-2xl sm:text-3xl md:text-4xl leading-tight text-gray-500">
              Voter Registration Deadline
            </h3>
            <p className="capitalize text-xl sm:text-2xl md:text-4xl leading-tight text-brand-red md:tracking-tight">
              October 5, 2020
            </p>
            <h4 className="mt-3 font-bold capitalize md:text-xl leading-tight">
              Deadline to Request an Absentee Ballot:
            </h4>
            <p className=" md:text-xl">
              Request for Postal Ballot by Thu Oct 22, 2020 11:59PM EDT
            </p>
            <h4 className="mt-3 font-bold capitalize md:text-xl leading-tight">
              Deadline to Return Completed Absentee Ballot:
            </h4>
            <p className=" md:text-xl">Tue Nov 3, 2020 6:00PM EDT</p>
          </article>

          <article className="mt-12 xl:mt-16 2xl:mt-20">
            <h3 className="font-sans uppercase font-medium tracking-wide text-2xl sm:text-3xl md:text-4xl leading-tight text-gray-500">
              Indiana General Election
            </h3>
            <p className="capitalize text-xl sm:text-2xl md:text-4xl leading-tight text-brand-red md:tracking-tight">
              November 3, 2020
            </p>
            <h4 className="mt-3 font-bold capitalize md:text-xl leading-tight">
              Early Voting:
            </h4>
            <p className=" md:text-xl">Not available</p>
            <h4 className="mt-3 font-bold capitalize md:text-xl leading-tight">
              In-Person Absentee Voting:
            </h4>
            <p className=" md:text-xl">Oct 6, 2020 - Nov 2, 2020</p>
          </article>
        </div>
      </div>
    </div>
  )
}
